export const LOADING_CELL_TEXT = "Loading..."
export const NOT_APPLICABLE_TEXT = "--"
export const MISSING_VALUE_TEXT = "-"
